import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PagingAndSortingDataTable from '../../../../widgets/data-table/PagingAndSortingDataTable/PagingAndSortingDataTable';
import {
  getColumns,
  sortLineItems
} from '../../../../presenters/renewals/RenewalProductListPage/renewal-product-columns';
import { Hidden, IconButton, Tooltip } from '@material-ui/core';
import { Visibility, Info } from '@material-ui/icons';
import { mapLineItems } from '../../../../presenters/renewals/RenewalProductListPage/product-list-page-util';
import * as api from '../../../../../services/api';
import { PRODUCT_DETAILS_URL } from '../../../../../route-names';
import { withRouter } from 'react-router';
import LoadingWidget from '../../../../widgets/LoadingWidget/LoadingWidget';
import {
  getValidationMessages,
  normalizeCustomerProducts,
  normalizeRenewalLineItems,
  filterOutSuppressedItems
} from '../../../../../utils/renewals-util';
import { injectIntl } from 'react-intl';

class RenewalLineItemListWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      customerProducts: []
    };

    this._isMounted = false;
    this.loadInitialState = this.loadInitialState.bind(this);
    this.getMappedColumns = this.getMappedColumns.bind(this);
    this.getMappedLineItems = this.getMappedLineItems.bind(this);
    this.getAllLineItems = this.getAllLineItems.bind(this);
    this.lineItemIsValid = this.lineItemIsValid.bind(this);
    this.onSelectLineItem = this.onSelectLineItem.bind(this);
    this.getLineItemValidationMessages =
      this.getLineItemValidationMessages.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadInitialState();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadInitialState() {
    if (!this.props.renewal) {
      api.customerProducts
        .getLineItemsByCustomer({
          branchId: this.props.customer.branchId,
          routeNumber: this.props.customer.routeNumber,
          customerId: this.props.customer.customerId
        })
        .then((customerProductsResponse) => {
          if (this._isMounted) {
            this.setState({
              customerProducts: customerProductsResponse.data,
              loading: false
            });
          }
        })
        .catch((error) => {
          throw Error('unable to download line items');
        });
    } else {
      this.setState({
        loading: false
      });
    }
  }

  getMappedColumns() {
    return [
      ...getColumns({
        ...this.props,
        appConfigs: this.props.appConfigs,
        intl: this.props.intl,
        lineItems: this.getMappedLineItems()
      }),
      {
        header: {
          display: ''
        },
        accessor: (lineItem) => ({
          display: !!this.props.renewal ? (
            <div style={{ float: 'right', display: 'flex' }}>
              <Hidden xsUp={this.lineItemIsValid(lineItem)}>
                <Tooltip
                  title={this.props.intl.formatMessage({
                    id: 'line_item_requires_approval'
                  })}
                  placement="left"
                >
                  <IconButton
                    disableRipple
                    iconclassname="details-icon material-icons"
                    label={this.props.intl.formatMessage({
                      id: 'approval_required_reason'
                    })}
                  >
                    <Info />
                  </IconButton>
                </Tooltip>
              </Hidden>
              <IconButton
                iconclassname="details-icon material-icons"
                onClick={() => this.onSelectLineItem(lineItem.lineItemId)}
                disabled={!lineItem.isAdjustable}
                label={this.props.intl.formatMessage({ id: 'product_details' })}
              >
                <Visibility />
              </IconButton>
            </div>
          ) : null,
          ignoreOnClick: true
        })
      }
    ];
  }

  getMappedLineItems() {
    const allLineItems = this.getAllLineItems();
    const {customerProducts} = this.state;
    const mappedLineItems = mapLineItems(
      this.props.renewal,
      this.props.customer,
      allLineItems,
      this.onSelectLineItem
    );

    const enrichedLineItems = mappedLineItems.map((lineItem) => {
      const matchedProduct = this.state.customerProducts.find(
        (cp) => cp.productCode === lineItem.productCode
      );

      return {
        ...lineItem,
        plpcDateActive: matchedProduct?.plpcDateActive || null,
        plpcDateInactive: matchedProduct?.plpcDateInactive || null
      };
    });

    return enrichedLineItems;
  }

  getAllLineItems() {
    const normalizedLineItems = !!this.props.renewal
      ? normalizeRenewalLineItems(this.props.renewal, this.props.intl)
      : normalizeCustomerProducts(this.state.customerProducts, this.props.intl);
    return filterOutSuppressedItems(normalizedLineItems);
  }

  lineItemIsValid(lineItem) {
    const lineItemValidations = this.getLineItemValidationMessages(
      lineItem.lineItemId
    );
    return lineItemValidations.length === 0;
  }

  onSelectLineItem(lineItemId) {
    this.props.history.push(
      PRODUCT_DETAILS_URL.replace(
        ':branchRouteCustomerId',
        this.props.customer.branchRouteCustomerId
      ).replace(':lineItemId', lineItemId)
    );
  }

  getLineItemValidationMessages(lineItemId) {
    return getValidationMessages(
      this.props.renewal,
      (validation) => validation.lineItemId === lineItemId
    );
  }

  render() {
    return this.state.loading ? (
      <LoadingWidget />
    ) : (
      <div>
        <div className="customer-data-table-row row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 m-b-15 ">
            <PagingAndSortingDataTable
              columns={this.getMappedColumns()}
              bodyData={this.getMappedLineItems()}
              sort={sortLineItems}
              defaultSortByKey="DEFAULT"
            />
          </div>
        </div>
      </div>
    );
  }
}

RenewalLineItemListWrapper.propTypes = {
  renewal: PropTypes.object,
  customer: PropTypes.object.isRequired,
  appConfigs: PropTypes.array,
  intl: PropTypes.object
};

export default injectIntl(withRouter(RenewalLineItemListWrapper));